import React from "react";

// MUI
import styled from "@emotion/styled";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

const Container = styled("div")(({ theme, radius }) => ({
  width: "100%",
  "& .MuiInputLabel-root": {
    fontSize: "15px",
    color: "#4F4F4F",
    [theme.breakpoints.down('xl')]: {
      fontSize: "14px",
    }
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: radius,
  },
  "& .MuiOutlinedInput-root": {
    paddingLeft: "8px",
  },
  "& .MuiInputAdornment-root": {
    marginRight: 0,
  },
  "& .Mui-focused": {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#00A0E3",
      borderWidth: "1px",
    },
  },
  "& svg": {
    padding: "0 0.5rem",
    minHeight: "20px",
    width: "36px"
  },
  "& .MuiInputBase-input": {
    padding: "0.5rem 0.5rem 0.5rem 0",
    height: "16px",
    fontSize: "13px",
  },
  "& .text-field-style": {
    fontSize: "13px",
    height: "15px",
    color: "#222222",
    [theme.breakpoints.down('xl')]: {
      height: "15px",
      fontSize: "14px",
    },
  }
}))

const CustomTextField = ({
  value,
  label,
  inputProps,
  radius="0px",
  Outsidelabel=null,
  ...restProps
}) => {
  let newinputprops = {
    className: "text-field-style"
  };
  return (
    <Container radius={radius}>
      {Outsidelabel}
      <TextField
        label={label}
        size="small"
        sx={{
          width: "100%",
        }}
        value={value}
        {...restProps}
        inputProps={inputProps ? inputProps : { newinputprops }}
      />
    </Container>
  );
};

export default CustomTextField;